import * as yup from "yup";

export const userSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  phone: yup.string().required("Phone number is required"),
  roles: yup
    .array()
    .min(1, "At least one role must be selected")
    .required("Roles are required"),
});

// Build a role-aware schema for conditional fields
export const getUserSchema = (roleName = "") => {
  const role = String(roleName || "").toLowerCase();

  const base = userSchema.shape({
    // Common for Player/Scout/Coach
    dateOfBirth: ["player", "scout", "coach"].includes(role)
      ? yup
          .string()
          .required("Date of birth is required")
          .test(
            "is-valid-date",
            "Please enter a valid date of birth",
            (val) => {
              if (!val) return false;
              return !isNaN(Date.parse(val));
            }
          )
      : yup.string().nullable(),
    city: ["player", "scout", "coach"].includes(role)
      ? yup.string().required("City is required")
      : yup.string().nullable(),
    state: ["player", "scout", "coach"].includes(role)
      ? yup.string().required("State is required")
      : yup.string().nullable(),
    country: ["player", "scout", "coach"].includes(role)
      ? yup
          .string()
          .required("Country is required")
          .test(
            "is-australia",
            "Country must be Australia",
            (val) =>
              String(val || "")
                .trim()
                .toLowerCase() === "australia"
          )
      : yup.string().nullable(),

    // Player specific
    height:
      role === "player"
        ? yup
            .string()
            .required("Height is required for Player role")
            .test("is-decimal", "Height must be a valid number", (val) =>
              val === undefined || val === null || val === ""
                ? false
                : !isNaN(parseFloat(val))
            )
        : yup.string().nullable(),
    weight:
      role === "player"
        ? yup
            .string()
            .required("Weight is required for Player role")
            .test("is-decimal", "Weight must be a valid number", (val) =>
              val === undefined || val === null || val === ""
                ? false
                : !isNaN(parseFloat(val))
            )
        : yup.string().nullable(),
    position:
      role === "player"
        ? yup.string().required("Position is required for Player role")
        : yup.string().nullable(),
    preferredPosition:
      role === "player"
        ? yup
            .string()
            .required("Preferred Position is required for Player role")
        : yup.string().nullable(),
    dominantFoot:
      role === "player"
        ? yup
            .string()
            .required("Dominant Foot is required for Player role")
            .test(
              "is-valid-foot",
              "Dominant Foot must be either 'left' or 'right'",
              (val) =>
                ["left", "right"].includes(String(val || "").toLowerCase())
            )
        : yup.string().nullable(),
    skills:
      role === "player"
        ? yup.string().required("Skills is required for Player role")
        : yup.string().nullable(),

    // Scout/Coach specific
    club: ["scout", "coach"].includes(role)
      ? yup.string().required("Club is required for Scout and Coach roles")
      : yup.string().nullable(),
  });

  return base;
};

export const roleSchema = yup.object().shape({
  displayName: yup.string().required("Name field is required"),
});

export const sportSchema = yup.object().shape({
  name: yup
    .string()
    .required("Sports name field is required")
    .max(50, "Name must be 50 characters"),
});

export const permissionSchema = yup.object().shape({
  displayName: yup.string().required("Name field is required"),
  description: yup
    .string()
    .required("Description field is required")
    .max(250, "Description must be  250 characters"),
});

export const moduleSchema = yup.object().shape({
  name: yup.string().required("Name field is required"),
});

export const pageSchema = yup.object().shape({
  page_name: yup.string().required("Name field is required"),
  page_url: yup.string().required("URL field is required"),
  page_icon: yup.string().required("ICON field is required"),
});

export const modulePagesSchema = yup.object().shape({
  moduleId: yup.string().required("Module name field is required"),
  name: yup.string().required("Required"),
});

export const moduleRolesSchema = yup.object().shape({
  role_id: yup.string().required("Role name field is required"),
  module_id: yup
    .array()
    .min(1, "Module must be selected")
    .required("Rrequired"),
});

export const pagePermissionSchema = yup.object().shape({
  permission: yup.array().of(
    yup.object({
      module_id: yup.string().required("Module is required"),
      role_id: yup.string().required("Role is required"),
      page_id: yup.string().required("Page is required"),
    })
  ),
});
